module.exports = __webpack_public_path__ + "img/c.b09ef08c.jpg";